import React, { forwardRef } from 'react';
import { ChevronDown } from 'lucide-react';
import { Label, ErrorText } from './Typography';

/**
 * Granular Form Components used by Tower Projects modules
 * These leverage the same design system as FormInput/FormSelect
 */

export const FormField = ({ label, error, required, children, className = '', field }) => (
  <div className={`space-y-1.5 text-[13px] font-medium ${className}`}>
    {label && (
      <Label htmlFor={field} required={required}>
        {label}
      </Label>
    )}
    {children}
    {error && <ErrorText>{error.message || error}</ErrorText>}
  </div>
);

export const Input = forwardRef(({ className = '', ...props }, ref) => (
  <input
    ref={ref}
    className={`w-full h-[35px] px-3 text-[12px] border border-slate-200 rounded-md text-[13px] text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-1 focus:border-brand-blue focus:ring-brand-blue/30 transition-all bg-white leading-none ${className}`}
    {...props}
  />
));

export const Select = forwardRef(({ children, className = '', ...props }, ref) => (
  <div className="relative">
    <select
      ref={ref}
      className={`w-full h-[35px] px-3 text-[12px] pr-9 border border-slate-200 rounded-md text-[13px] text-slate-800 appearance-none cursor-pointer focus:outline-none focus:ring-1 focus:border-brand-blue focus:ring-brand-blue/30 transition-all bg-white ${className}`}
      {...props}
    >
      {children}
    </select>
    <ChevronDown className="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" />
  </div>
));

export const Textarea = forwardRef(({ className = '', ...props }, ref) => (
  <textarea
    ref={ref}
    className={`w-full border text-[12px] border-slate-200 rounded-md px-3 py-2.5 text-[13px] text-slate-800 placeholder-slate-400 resize-none focus:outline-none focus:ring-1 focus:border-brand-blue focus:ring-brand-blue/30 transition-all bg-white leading-relaxed ${className}`}
    {...props}
  />
));

FormField.displayName = 'FormField';
Input.displayName = 'Input';
Select.displayName = 'Select';
Textarea.displayName = 'Textarea';




